import { render, staticRenderFns } from "./Doctors.vue?vue&type=template&id=1b70a24c&scoped=true"
import script from "./Doctors.vue?vue&type=script&lang=js"
export * from "./Doctors.vue?vue&type=script&lang=js"
import style0 from "./Doctors.vue?vue&type=style&index=0&id=1b70a24c&prod&scoped=true&lang=css"
import style1 from "./Doctors.vue?vue&type=style&index=1&id=1b70a24c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b70a24c",
  null
  
)

export default component.exports